import styled from 'styled-components';
import { Card } from 'components';

const commonStyle = `
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 90%;
	backface-visibility: hidden;
	transition: 0.5s;
	margin: 0px 20px 0px 0px;
`;

export const UiFrontCard = styled(Card)`
	transform: rotateY(0deg);
	${commonStyle}
`;

export const UiTemp = styled.div`
	height: 37%;
`;
export const UiBackCard = styled(Card)`
	transform: rotateY(180deg);
	${commonStyle}
`;

export const UiFlipCard = styled.div`
	position: relative;
	transform-style: preserve-3d;
	perspective: 1000px;
	transition: 0.5s;
	width: 100%;
	height: 90%;
	margin: 0px 20px 0px 0px;

	transform: ${({ isRotate }) => (isRotate ? 'rotateY(180deg)' : 'rotateY(0)')};
	transition: 0.5s;
`;
